import { validate, ValidationError } from 'class-validator';
import { Usuario } from './../entities/usuario.entity';
import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import { AltaUsuario } from '../entities/altausuario.entity';
import { RegisterUser } from '../entities/RegisterUser.entity';
import { Explotacion } from '../entities/explotacion.entity';
import { Respuesta } from '../entities/respuesta.entity';
import { environment } from '../../environments/environment';
import { CodTelefono, Naciones } from '../entities/naciones';
import { UserServiceA2P } from '../services/userA2P.service';
import { Login } from '../entities/login.entity';

export interface FormModel {
    captcha?: string;
}

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styles: [`
    .error { color: crimson; }
    .success { color: green; }
  ` ],
})

export class RegisterComponent implements OnInit {
    public nombreApellidos: string;
    public email: string;
    public dni: string;
    public poblacion: number;
    public contrato: number;
    public factura: string;
    public importe: number;
    public codigoTelefono: string = CodTelefono.COD_TELEFONO_DEFAULT;
    public codigoTelefono2: string = CodTelefono.COD_TELEFONO_DEFAULT;
    public telefono: string;
    public telefono2: string;
    public Efactura: boolean;
    public alerts: Array<string> = [];
    public resultado: Respuesta;
    public messageCabecera: string;
    public typeException: number;
    public messageComplet: string;
    public politicas: boolean;
    public explotaciones: Explotacion[];
    public usuario: RegisterUser = new RegisterUser();
    public usuarioAlta: AltaUsuario;
    public usuarioNew: Usuario = new Usuario();
    public userExist: boolean;
    public formularioErroneo = false;
    public testMessages: Array<string> = [];
    public nombreApellidosInputError: Boolean;
    public emailInputError: Boolean;
    public dniInputError: Boolean;
    public poblacionInputError: Boolean;
    public contratoInputError: Boolean;
    public facturaInputError: Boolean;
    public importeInputError: Boolean;
    public telefono1InputError: Boolean;
    public telefono2InputError: Boolean;
    public politicasError: Boolean;
    public showSpinner = false;
    public selectedCar: string;
    public condicionesEnvio: string;
    public avisoEmail: string;
    public formModel: FormModel = {};
    public keyCapchasite: string;
    public captchaError: boolean;
    public telefonoexplotacion: string;
    public telefonoexplotacion2: string;
    public isVisible = true;
    public codigosTelefono: Naciones[];
    public onDniChange(value: string) { this.dni = (value || '').toUpperCase().replace(/\s+/g, ''); }

    constructor(private userService: UserService, private sessionService: SessionService, private userServiceA2P : UserServiceA2P) { }

    public ngOnInit() {
        this.clearInputErrors();
        this.Efactura = true;
        this.userExist = false;
        this.poblacion = -1;
        this.sessionService.datosExplotacion = new Explotacion();
        this.condicionesEnvio = 'Seleccione población';
        this.sessionService.datosExplotacion.CondicionesEnvio = null;
        this.explotaciones = this.sessionService.Explotaciones;
        if (this.explotaciones.length === 1) {
            this.poblacion = 0;
            this.sessionService.datosExplotacion = this.explotaciones[0];
            this.cargarDatos();
        }
        this.keyCapchasite = environment.capchasiteKey;

    }

    public ActualizarUser(): void {
        this.usuario.AltaUsuario.ActualizarSiExiste = true;
        this.onSubmit();
        this.userExist = false;
    }

    public onSubmit(): void {
        if (this.poblacion !== -1) {
            this.usuarioAlta = new AltaUsuario();
            this.usuarioAlta.CodExplotacion = this.explotaciones[this.poblacion].Codigo;
            if (this.explotaciones[this.poblacion].Codigo.toUpperCase() === 'MELILLA') {
                this.usuarioAlta.SerieFranumFra = (this.factura === undefined) ? '-' : this.factura;
            } else {
            
                if(document.getElementById('top') !== null)    
                document.getElementById('top').scrollIntoView();        
            
                this.usuarioAlta.SerieFranumFra = (this.factura === undefined) ? '' : this.factura;
            }
            this.usuarioAlta.Contrato = this.contrato;
            this.usuarioAlta.ImporteUltimaFactura = this.importe;
            this.usuarioNew.Nombre = this.nombreApellidos;
            this.usuarioNew.EMail = this.email;
            this.usuarioNew.Telefono1 = this.codigoTelefono + '-' + this.telefono;
            this.usuarioNew.Telefono2 = this.telefono2 ? this.codigoTelefono2 + '-' + this.telefono2 : null;
            this.usuarioNew.EFactura = this.Efactura;
            this.usuarioNew.Login = this.dni;
            this.usuario.AltaUsuario = this.usuarioAlta;
            this.usuario.Usuario = this.usuarioNew;
            this.usuario.gRecaptchaResponse = this.formModel.captcha;
            this.clearInputErrors();
            this.formularioErroneo = true;
            this.formModel.captcha = this.formModel.captcha === undefined ? null : this.formModel.captcha;
            if (!this.usuario.AltaUsuario.ActualizarSiExiste) {
                validate(this.usuario).then(resultado => {
                    if (resultado.length > 0 || this.formModel.captcha === null || this.politicas === false) {
                        this.showErrors(resultado);
                    } else {
                        this.userService.registerUser(this.explotaciones[this.poblacion].Codigo, this.usuario).subscribe(
                            response => this.registerUserOnSuccess(),
                            response => this.registerUserOnError(response)
                        );
                    }
                });
            } else {
                validate(this.usuario).then(resultado => {
                    if (resultado.length > 0 || this.politicas === false) {
                        this.showErrors(resultado);
                    } else {
                        this.userService.registerUser(this.explotaciones[this.poblacion].Codigo, this.usuario).subscribe(
                            response => this.registerUserOnSuccess(),
                            response => this.registerUserOnError(response)
                        );
                    }
                });
            }
        } else {
            this.poblacionInputError = true;
        }
        
    }

    private clearInputErrors() {
        this.nombreApellidosInputError = false;
        this.emailInputError = false;
        this.dniInputError = false;
        this.poblacionInputError = false;
        this.contratoInputError = false;
        this.facturaInputError = false;
        this.importeInputError = false;
        this.telefono1InputError = false;
        this.telefono2InputError = false;
        this.captchaError = false;
        this.politicasError = false;
    }

    private showErrors(resultado: ValidationError[]) {
        if (resultado.length > 0) {
            for (const errores of resultado) {
                for (const item of errores.children) {
                    switch (item.property) {
                        case 'Login':
                            this.dniInputError = true;
                            break;
                        case 'Nombre':
                            this.nombreApellidosInputError = true;
                            break;
                        case 'SerieFranumFra':
                            this.facturaInputError = true;
                            break;
                        case 'EMail':
                            this.emailInputError = true;
                            break;
                        case 'Telefono1':
                            this.telefono1InputError = true;
                            break;
                        case 'Telefono2':
                            this.telefono2InputError = true;
                            break;
                        case 'Contrato':
                            this.contratoInputError = true;
                            break;
                        case 'CodExplotacion':
                            this.poblacionInputError = true;
                            break;
                        case 'politicas':
                            this.politicasError = true;
                            break;
                    }
                }
            }
        }
        if (this.formModel.captcha === null) {
            this.captchaError = true;
        }
        this.politicasError = !this.politicas;
        this.importeInputError = isNaN(this.importe);
    }

    private registerUserOnSuccess(): void {
        this.usuario.AltaUsuario.ActualizarSiExiste = false;
        this.messageCabecera = 'Usuario registrado correctamente';
        this.typeException = 2;
        this.messageComplet = 'Su solicitud de registro se ha realizado correctamente. En breve recibirá en su correo electrónico (' +
            this.usuario.Usuario.EMail + ') un correo de confirmación con su clave de acceso';
    }

    private registerUserOnError(response): void {
        this.formModel.captcha = null;
        this.resultado = response;
        if (this.resultado.Ex !== undefined) {
            if (this.resultado.ErrNumber === 3502 && !this.usuario.AltaUsuario.ActualizarSiExiste) {
                this.userExist = true;
                this.messageCabecera = 'Usuario existe';
                this.messageComplet = this.resultado.Ex.Message;
                this.typeException = 4;
            } else {
                this.messageCabecera = 'Error en registro de usuario';
                this.messageComplet = this.resultado.Ex.Message;
                this.typeException = this.resultado.TipoExcepcion;
            }
        } else {
            this.messageCabecera = 'Error registro';
            this.messageComplet = 'Error al registrar el usuario, compruebe que sus datos son correctos';
            this.typeException = 1;
        }
    }

    public cargarDatos() {
        if (this.poblacion !== -1) {
            this.sessionService.datosExplotacion = this.explotaciones[this.poblacion];
            if (this.sessionService.datosExplotacion.Codigo.toUpperCase() === 'MELILLA') {
                this.isVisible = false;
            } else {
                this.isVisible = true;
            }
            if (this.sessionService.datosExplotacion && this.sessionService.datosExplotacion.Contacto) {
                const TelsArray = this.sessionService.datosExplotacion.Contacto.split('-');
                this.telefonoexplotacion = TelsArray[0];
                this.telefonoexplotacion2 = TelsArray[1];
            }
            /* this.telefonoexplotacion = (this.sessionService.datosExplotacion === undefined ||
                this.sessionService.datosExplotacion.Contacto === null) ? '' :
                this.sessionService.datosExplotacion.Contacto.substring(2, (this.sessionService.datosExplotacion.Contacto.length - 1)
            ); */
            this.avisoEmail = 'Atención!!! La respuesta a su solicitud puede recibirla en la carpeta de correo no deseado.' +
                'En el caso de cuentas de correo de Hotmail, vemos necesario añadir previamente a sus contactos la cuenta ' +
                this.explotaciones[this.poblacion].Email + ' para asegurarse de que recibirá nuestros correos.';
            this.condicionesEnvio = this.explotaciones[this.poblacion].PoliticaEnvio;
            this.getNaciones();
        } else {
            this.sessionService.datosExplotacion = new Explotacion();
            this.sessionService.datosExplotacion.CondicionesEnvio = null;
            this.avisoEmail = null;
            this.condicionesEnvio = 'Seleccione población';
        }
    }
    
    /**
     * Obtiene la lista de códigos de teléfono por país.
     * @param {string} explotacion - Código de explotación.
     * @returns {Observable<any>} - Un observable que contiene la lista de naciones para la explotación especificada.
     */
      private getNaciones(){
        this.userService.getNaciones(this.sessionService.datosExplotacion.Codigo).subscribe(
          data => {
        this.codigosTelefono = data;
          },
          error => {
            this.messageCabecera = 'Error';
            this.messageComplet = 'Error al obtener los códigos de teléfono';
            this.typeException = 1;
          }
        );
      }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/public/register.component.ts